import React from 'react';
import { Input, AutoComplete, Menu, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './OfferedItems.module.scss';
import { useTranslation } from 'react-i18next';
import { OfferedItemSearchOption } from './useSearchOfferedItemsOptions';

const { Title, Text } = Typography;

type Props = {
  categories: string[];
  activeCategory?: string;
  searchValue: string;
  options: OfferedItemSearchOption[];
  onSearch: (v: string) => void;
  onSelect: (v: string, o: any) => void;
  onCategoryClick: (cat: string) => void;
};

export const OfferedItemsHeader: React.FC<Props> = (props) => {
  const {
    categories,
    activeCategory,
    searchValue,
    options,
    onSearch,
    onSelect,
    onCategoryClick,
  } = props;

  const { t } = useTranslation(undefined, {
    keyPrefix: 'personalization.floorplan.offeredItems',
  });

  return (
    <div className={styles.header}>
      <Title level={4}>{t('title')}</Title>

      <AutoComplete
        options={options}
        value={searchValue}
        onSearch={onSearch}
        onSelect={onSelect}
        style={{ width: '100%' }}
        className="mb-2"
      >
        <Input prefix={<SearchOutlined />} placeholder={t('search')} />
      </AutoComplete>

      <Menu
        mode="horizontal"
        selectedKeys={activeCategory ? [activeCategory] : []}
      >
        {categories.map((cat) => (
          <Menu.Item key={cat} onClick={() => onCategoryClick(cat)}>
            <Text strong={cat === activeCategory}>{cat}</Text>
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );
};
